import(/* webpackMode: "eager" */ "/home/zillehuma/zysoftec/source/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/zillehuma/zysoftec/source/node_modules/next/dist/client/image-component.js");
